/* DNA speed fix 11Oct26
   The theme's image-resize helper only understood .jpg/.png/.gif file names, so .webp product
   photos in "Recently viewed" and "Wishlist" were loaded at full original size (often 100-250 KB each).
   This version resizes any Shopify image (webp, jpg, png...) with Shopify's CDN width/height parameters. */
(function () {
  window.Shopify = window.Shopify || {};
  window.Shopify.resizeImage = function (src, size, crop) {
    if (!src) return src;
    try {
      var m = String(size || '').match(/(\d+)x(\d+)/);
      var abs = String(src).indexOf('//') === 0 ? 'https:' + src : String(src);
      var u = new URL(abs, window.location.origin);
      if (m) {
        u.searchParams.set('width', m[1]);
        u.searchParams.set('height', m[2]);
        if (crop) u.searchParams.set('crop', crop);
      }
      return u.toString();
    } catch (e) {
      return src;
    }
  };
})();

/* DNA speed fix 19Oct26
   Product gallery photos 2+ are rendered with data-dna-src / data-dna-srcset so they don't compete with photo 1.
   Load them once the page has finished loading, or as soon as the shopper interacts.
   A MutationObserver also covers galleries added later (quick view popup). */
(function () {
  var ready = false;
  function swap() {
    document.querySelectorAll('img[data-dna-src], img[data-dna-srcset]').forEach(function (img) {
      if (img.dataset.dnaSrcset) { img.srcset = img.dataset.dnaSrcset; img.removeAttribute('data-dna-srcset'); }
      if (img.dataset.dnaSrc) { img.src = img.dataset.dnaSrc; img.removeAttribute('data-dna-src'); }
    });
  }
  function go() { ready = true; swap(); }
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (e) { window.addEventListener(e, go, { passive: true }); });
  function later() { if ('requestIdleCallback' in window) { requestIdleCallback(go, { timeout: 2500 }); } else { setTimeout(go, 1500); } }
  if (document.readyState === 'complete') { later(); } else { window.addEventListener('load', later); }
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (ready && document.querySelector('img[data-dna-src], img[data-dna-srcset]')) swap();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
